// extracted by mini-css-extract-plugin
export default {"pureCode":"Markdown_pureCode__mE6Up","lang":"Markdown_lang__7ZHAj","copy":"Markdown_copy__zs8HM"};